import type { ReactElement } from 'react'
import { useI18n } from '../i18n/useI18n'
import type { Lang } from '../i18n/context'

export default function LanguageToggle(): ReactElement {
  const { lang, setLang } = useI18n()

  const pick = (next: Lang) => () => setLang(next)

  return (
    <div className="language-toggle" role="group" aria-label="Language">
      <button
        type="button"
        className={`lang-btn ${lang === 'no' ? 'active' : ''}`}
        onClick={pick('no')}
        aria-pressed={lang === 'no'}
      >
        NO
      </button>
      <span className="lang-sep" aria-hidden="true">/</span>
      <button
        type="button"
        className={`lang-btn ${lang === 'en' ? 'active' : ''}`}
        onClick={pick('en')}
        aria-pressed={lang === 'en'}
      >
        EN
      </button>
    </div>
  )
}
